import { Mutation, Query, QueryKey } from '@tanstack/react-query';
import { ApiErrorMessage, EHttpStatusCode, CommonApiError } from 'src/api';

export const useQueryErrorHandler = () => {
  return (error: unknown, query: Query<unknown, unknown, unknown, QueryKey> | Mutation<unknown, unknown, unknown, unknown>) => {
    if (typeof error === 'object' && error !== null && 'data' in error && 'status' in error) {
      const { status, data }: CommonApiError = error as CommonApiError;
      const messages: ApiErrorMessage = data.error?.messages;
      if (
        [EHttpStatusCode.BAD_REQUEST, EHttpStatusCode.FORBIDDEN, EHttpStatusCode.UNPROCESSABLE_CONTENT].includes(status) &&
        !query.meta?.preventDefaultBadRequest
      ) {
        const isObjectErrorMessage = messages && typeof messages !== 'string';

        if (query.meta?.setError && typeof query.meta.setError === 'function' && isObjectErrorMessage) {
          return query.meta.setError(messages);
        }

        return console.error(!isObjectErrorMessage ? (data.error.messages as string) : 'Something went wrong!');
      }

      if (status === EHttpStatusCode.NOT_FOUND || status >= EHttpStatusCode.INTERNAL_SERVER_ERROR) {
        return console.error(`${data.error.messages}`);
      }
    }

    return error;
  };
};
